
<template>
    <svg width="26" height="26" viewBox="0 0 26 26" fill="#151515" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.85861 13.2299C4.21622 13.2299 3.69546 13.7405 3.69546 14.3703V21.2124C3.69546 21.8422 4.21622 22.3527 4.85861 22.3527H21.1428C21.7852 22.3527 22.306 21.8422 22.306 21.2124V14.3703C22.306 13.7405 21.7852 13.2299 21.1428 13.2299H4.85861ZM1.36914 14.3703C1.36914 12.4809 2.93143 10.9492 4.85861 10.9492H21.1428C23.07 10.9492 24.6323 12.4809 24.6323 14.3703V21.2124C24.6323 23.1018 23.07 24.6334 21.1428 24.6334H4.85861C2.93143 24.6334 1.36914 23.1018 1.36914 21.2124V14.3703Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.9992 3.64789C12.3694 3.64789 11.8588 4.15844 11.8588 4.78824C11.8588 5.41804 12.3694 5.92859 12.9992 5.92859C13.629 5.92859 14.1395 5.41804 14.1395 4.78824C14.1395 4.15844 13.629 3.64789 12.9992 3.64789ZM9.57812 4.78824C9.57812 2.89884 11.1098 1.36719 12.9992 1.36719C14.8886 1.36719 16.4202 2.89884 16.4202 4.78824C16.4202 6.67763 14.8886 8.20929 12.9992 8.20929C11.1098 8.20929 9.57812 6.67763 9.57812 4.78824Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.9993 6.15625C13.755 6.15625 14.3677 6.6668 14.3677 7.2966V11.858C14.3677 12.4878 13.755 12.9984 12.9993 12.9984C12.2435 12.9984 11.6309 12.4878 11.6309 11.858V7.2966C11.6309 6.6668 12.2435 6.15625 12.9993 6.15625Z"
        />
    </svg>
</template>
<script>
export default {
    name: "GamepadIcon"
}
</script>
